export const kitchenDisplayListGet = (response) => {
  if (response && response.data && response.data.success === true) {
    const items = Array.isArray(response.data.data)
      ? response.data.data.map((item) => ({
          id: item.id,
          slack: item.slack,
          code: item.kitchen_display_code,
          name: item.label,
          status: item.status,
          status_data: item.status_data,
          categories: Array.isArray(item.categories)
            ? item.categories.map((id) => parseInt(id))
            : [],
          orange_timer: item.orange_timer,
          red_timer: item.red_timer,
          store_id: item.store_id,
          createdAt: item.created_at,
          updatedAt: item.updated_at,
          created_by: item.created_by,
          updated_by: item.updated_by
        }))
      : []
    return {
      success: true,
      total: response.data.total || items.length,
      data: items
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed',
    data: []
  }
}

export const kitchenDisplayDetailsGet = (response) => {
  if (response && response.data && response.data.success === true) {
    const data = response.data.data || {}
    return {
      success: true,
      data: {
        ...data,
        categories: Array.isArray(data.categories)
          ? data.categories.map((category) => {
              // If category is already an object with name, use it
              if (typeof category === 'object' && category.name) {
                return category
              }
              // If category is just an ID, create an object with id
              return {
                id: parseInt(category),
                name: `Category ${category}` // Fallback name
              }
            })
          : []
      }
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed',
    data: {}
  }
}

export const kitchenDisplayCreatePost = (response) => {
  console.log('API Response:', response) // Debug log
  console.log('API Response Data:', response?.data) // Debug log
  console.log('API Response Status:', response?.status) // Debug log

  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Kitchen Display created',
      data: response.data.data || null
    }
  }
  return { success: false, message: 'Failed to create' }
}

export const kitchenDisplayUpdatePut = (response) => {
  console.log('Update API Response:', response) // Debug log

  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Kitchen Display updated',
      data: response.data.data || null
    }
  }
  return { success: false, message: 'Failed to update' }
}

export const kitchenDisplayDeleteDel = (response) => {
  console.log('Delete Model Response:', response)
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Kitchen Display deleted'
    }
  }
  return { success: false, message: 'Failed to delete' }
}
